import { connect } from 'react-redux';
import {
  fetchDownloadRequests,
  deleteDownloadRequest
} from '../../redux/sagas/download-request/routines';
import {
  getIsFetching,
  getIsFetched,
  getOrder,
  getDownloadRequestsQuery,
  getIsDeleting as getIsDeletingReport,
  getIsDeleted as getIsDeletedReport,
  getDeletingError as getDeleteReportError
} from '../../redux/selectors/download-request';
import {
  setDownloadRequestsQuery,
  clearDownloadRequests,
  downloadRequestsOnChangePage
} from '../../redux/actions/download-request';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageItems
} from '../../redux/selectors/download-request/pagination';
import paginationAndSearchQuery from '../../helpers/paginationAndSearchQuery';
import DownloadRequestList from '../../components/DownloadRequestList';

function mapStateToProps(state, props) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getDownloadRequestsQuery(state);
  const order = getOrder(state);

  return {
    ...props,
    downloadRequests: getCurrentPageItems(state),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getIsFetching(state),
    isFetched: getIsFetched(state),
    isDeleting: getIsDeletingReport(state),
    isDeleted: getIsDeletedReport(state),
    deleteError: getDeleteReportError(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: ({ context, order }) => {
      dispatch(setDownloadRequestsQuery({ context, order }));
      dispatch(fetchDownloadRequests({ context, order }));
    },
    onDelete: report => {
      dispatch(deleteDownloadRequest(report));
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchDownloadRequests(query));
      else dispatch(downloadRequestsOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearDownloadRequests());
      dispatch(fetchDownloadRequests(query));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadRequestList);
